
(function(){
  "use strict";

  // ---------------------------------------------------------------------------
  // Unlike the golf builder, geometry is NOT a module constant here - a 25 mm
  // marker and a 38 mm marker are the same tool with different numbers. PRINT_D,
  // DISC_D and LINE_MAX are reassigned by setScene() and everything downstream
  // reads them unchanged.
  //
  // Nathan, 8 Sep 2026, measured not estimated:
  //   25 mm marker - printable area is the FULL 25 mm, no margin.
  //   38 mm marker - printable area is ~32 mm, excluding the bevelled edge.
  // The tools (hat clip, both divot tools) all carry a 25 mm disc.
  var PRINT_D = 25.0;          // usable print circle, mm - set per scene
  var DISC_D  = 25.0;          // visible disc diameter, mm - set per scene
  var MIN_CAP = 2.0;           // legibility floor, mm. Carried over from the golf
                               // work. A flat brushed disc is a KINDER surface than
                               // a dimpled ball, so this is conservative here rather
                               // than optimistic - worth revisiting against a print.
  var LINE_MAX  = [11, 13, 13, 11];   // set per scene
  var MAX_LINES = 4;
  // ---------------------------------------------------------------------------

  var VIEW = 400;                        // svg units
  var PXMM = VIEW / DISC_D;              // svg units per mm, recomputed per scene
  var CX = VIEW/2, CY = VIEW/2;
  // PXMM stays the true-proportion scale for the SYNTHETIC layout maths below;
  // on-screen the disc is sized from the photograph instead (DISC_R_VIEW).

  // Advance widths per em, worst case, measured off the same faces the puck uses.
  // cap height and MAX letter advance, both per em, read off the same font files the
  // puck builder uses (assets/pab-glyphs.js). Max, not mean: sizing on the average
  // advance let an all-wide string like "AAAAAAAAAAA" run 13% past the print circle.
  // Assuming every character is the widest in the face is conservative - typical text
  // could sit larger - but it cannot overflow. Sharing the puck's per-glyph tables
  // when this reaches the storefront removes the compromise entirely.
  // Per-character advance widths, per em, read off the same font files the puck
  // builder uses. Measuring the actual string beats assuming every letter is the
  // widest in the face: on realistic text that assumption cost about 25% of the
  // type size for no benefit. The max-advance value stays on each font row as the
  // fallback for any character not in the table.
  var ADV = {"Oswald":{" ":0.256,"A":0.551,"B":0.588,"C":0.563,"D":0.586,"E":0.447,"F":0.434,"G":0.582,"H":0.61,"I":0.301,"J":0.349,"K":0.567,"L":0.443,"M":0.704,"N":0.561,"O":0.586,"P":0.571,"Q":0.586,"R":0.6,"S":0.514,"T":0.445,"U":0.588,"V":0.526,"W":0.697,"X":0.515,"Y":0.493,"Z":0.433,"0":0.55,"1":0.385,"2":0.514,"3":0.514,"4":0.524,"5":0.509,"6":0.538,"7":0.439,"8":0.521,"9":0.538,"'":0.17,"-":0.324,"\u00c0":0.551,"\u00c1":0.551,"\u00c2":0.551,"\u00c4":0.551,"\u00c6":0.708,"\u00c7":0.563,"\u00c8":0.447,"\u00c9":0.447,"\u00ca":0.447,"\u00cb":0.447,"\u00cd":0.301,"\u00ce":0.301,"\u00cf":0.301,"\u00d1":0.561,"\u00d3":0.586,"\u00d4":0.586,"\u00d6":0.586,"\u00d8":0.572,"\u00d9":0.588,"\u00da":0.588,"\u00db":0.588,"\u00dc":0.588,"\u00dd":0.493},"Anton":{" ":0.2344,"A":0.4854,"B":0.4785,"C":0.4741,"D":0.4932,"E":0.4116,"F":0.3989,"G":0.4849,"H":0.499,"I":0.2266,"J":0.4663,"K":0.4722,"L":0.3975,"M":0.7461,"N":0.498,"O":0.4863,"P":0.4722,"Q":0.4937,"R":0.4766,"S":0.4614,"T":0.3955,"U":0.4736,"V":0.4692,"W":0.7119,"X":0.4839,"Y":0.4463,"Z":0.4102,"0":0.4941,"1":0.3306,"2":0.4941,"3":0.4941,"4":0.4941,"5":0.4941,"6":0.4941,"7":0.4941,"8":0.4941,"9":0.4941,"'":0.2139,"-":0.311,"\u00c0":0.4854,"\u00c1":0.4854,"\u00c2":0.4854,"\u00c4":0.4854,"\u00c6":0.6401,"\u00c7":0.4741,"\u00c8":0.4116,"\u00c9":0.4116,"\u00ca":0.4116,"\u00cb":0.4116,"\u00cd":0.2266,"\u00ce":0.2266,"\u00cf":0.2266,"\u00d1":0.498,"\u00d3":0.4863,"\u00d4":0.4863,"\u00d6":0.4863,"\u00d8":0.4863,"\u00d9":0.4736,"\u00da":0.4736,"\u00db":0.4736,"\u00dc":0.4736,"\u00dd":0.4463},"Graduate":{" ":0.35,"A":0.657,"B":0.684,"C":0.6,"D":0.69,"E":0.636,"F":0.596,"G":0.62,"H":0.792,"I":0.392,"J":0.54,"K":0.669,"L":0.556,"M":0.946,"N":0.812,"O":0.65,"P":0.624,"Q":0.65,"R":0.699,"S":0.6,"T":0.58,"U":0.74,"V":0.687,"W":1.026,"X":0.649,"Y":0.607,"Z":0.596,"0":0.65,"1":0.65,"2":0.65,"3":0.65,"4":0.65,"5":0.65,"6":0.65,"7":0.65,"8":0.65,"9":0.65,"'":0.24,"-":0.509,"\u00c0":0.657,"\u00c1":0.657,"\u00c2":0.657,"\u00c4":0.657,"\u00c6":0.947,"\u00c7":0.6,"\u00c8":0.636,"\u00c9":0.636,"\u00ca":0.636,"\u00cb":0.636,"\u00cd":0.392,"\u00ce":0.392,"\u00cf":0.392,"\u00d1":0.812,"\u00d3":0.65,"\u00d4":0.65,"\u00d6":0.65,"\u00d8":0.65,"\u00d9":0.74,"\u00da":0.74,"\u00db":0.74,"\u00dc":0.74,"\u00dd":0.607},"Archivo Black":{" ":0.333,"A":0.778,"B":0.778,"C":0.778,"D":0.778,"E":0.722,"F":0.667,"G":0.833,"H":0.833,"I":0.389,"J":0.667,"K":0.833,"L":0.667,"M":0.944,"N":0.833,"O":0.833,"P":0.722,"Q":0.833,"R":0.778,"S":0.722,"T":0.722,"U":0.833,"V":0.778,"W":1.0,"X":0.778,"Y":0.778,"Z":0.722,"0":0.667,"1":0.667,"2":0.667,"3":0.667,"4":0.667,"5":0.667,"6":0.667,"7":0.667,"8":0.667,"9":0.667,"'":0.278,"-":0.333,"\u00c0":0.778,"\u00c1":0.778,"\u00c2":0.778,"\u00c4":0.778,"\u00c6":1.0,"\u00c7":0.778,"\u00c8":0.722,"\u00c9":0.722,"\u00ca":0.722,"\u00cb":0.722,"\u00cd":0.389,"\u00ce":0.389,"\u00cf":0.389,"\u00d1":0.833,"\u00d3":0.833,"\u00d4":0.833,"\u00d6":0.833,"\u00d8":0.833,"\u00d9":0.833,"\u00da":0.833,"\u00db":0.833,"\u00dc":0.833,"\u00dd":0.778},"Big Shoulders Display":{" ":0.2135,"A":0.408,"B":0.4095,"C":0.4195,"D":0.4275,"E":0.3545,"F":0.35,"G":0.421,"H":0.4255,"I":0.201,"J":0.3905,"K":0.421,"L":0.3455,"M":0.636,"N":0.473,"O":0.428,"P":0.403,"Q":0.428,"R":0.4125,"S":0.4075,"T":0.3495,"U":0.4195,"V":0.4185,"W":0.6655,"X":0.4,"Y":0.3955,"Z":0.358,"0":0.4395,"1":0.2365,"2":0.424,"3":0.4365,"4":0.448,"5":0.446,"6":0.4325,"7":0.408,"8":0.433,"9":0.432,"'":0.178,"-":0.3815,"\u00c0":0.408,"\u00c1":0.408,"\u00c2":0.408,"\u00c4":0.408,"\u00c6":0.5795,"\u00c7":0.4195,"\u00c8":0.3545,"\u00c9":0.3545,"\u00ca":0.3545,"\u00cb":0.3545,"\u00cd":0.201,"\u00ce":0.201,"\u00cf":0.201,"\u00d1":0.473,"\u00d3":0.428,"\u00d4":0.428,"\u00d6":0.428,"\u00d8":0.428,"\u00d9":0.4195,"\u00da":0.4195,"\u00db":0.4195,"\u00dc":0.4195,"\u00dd":0.3955}};

  function widthEm(text, ff){
    var t = ADV[FONTS[ff][2]], max = FONTS[ff][5], w = 0;
    for(var i=0;i<text.length;i++){
      var a = t ? t[text.charAt(i)] : undefined;
      w += (a === undefined) ? max : a;
    }
    return w;                       // total advance in em units
  }

  var FONTS = [
    ["GLF-01","Block",     "Oswald",               700, 0.821, 0.708],
    ["GLF-02","Condensed", "Anton",                400, 0.870, 0.746],
    ["GLF-03","Collegiate","Graduate",             400, 0.750, 1.026],
    ["GLF-04","Heavy",     "Archivo Black",        400, 0.700, 1.000],
    ["GLF-05","Wide",      "Big Shoulders Display",700, 0.809, 0.665]
  ];
  // Gold ink is not offered on any disc. Nathan's call, 8 Sep 2026: every finish in
  // this range is a metal - silver, gold, bronze, chrome, or a steel disc set into a
  // black body - and gold ink is the least readable against all of them. It is dropped
  // from the list rather than blocked eight times over, because "no disc takes gold"
  // is one fact, and eight identical blocked maps would be eight chances to get it
  // wrong later.
  //
  // The per-scene `blocked` machinery stays for the restrictions that ARE per finish,
  // which Nathan is working out against the live builder.
  //
  // INK-05 is retired rather than reused, and White stays INK-06 - the same rule the
  // golf builder follows for the dropped yellow, so any spec string already written
  // down still resolves to what it meant when it was written. Gold remains available
  // on the GOLF builder, where the surface is a white or pink ball rather than metal.
  var INKS = [
    ["INK-01","Black",  "#141414"],
    ["INK-02","Red",    "#C8102E"],
    ["INK-03","Navy",   "#0B2545"],
    ["INK-04","Green",  "#1E6B45"],
    ["INK-06","White",  "#FFFFFF"]
  ];
  // Yellow dropped 29 Aug 2026 - not stocked. Ids are deliberately NOT renumbered:
  // BAL-03 stays pink so any spec string already written down still resolves.
  //
  // cx/cy/r are the ball's centre and radius as a FRACTION of the photo's width.
  //
  // Measured by flood-filling the ball from the image centre, then taking the
  // horizontal run at the equator - the bounding box alone under-measures, because
  // both balls blend into their own shadow where they meet the grass.
  //
  // The first pass scanned for bright low-saturation pixels and caught the SKY along
  // with the white ball: it put the white ball at r=0.1921 when it is 0.2007, which
  // rendered it 4.5% oversized and 13px low. The pink ball has no such neighbour and
  // measured correctly first time, which is why only the white one looked wrong.
  //
  // The values below are not the raw measurements. Pink's deployed figures sit a
  // little above true centre and Nathan confirmed that reads correctly - a ball on
  // grass looks right sitting slightly high. White carries the same offset applied
  // deliberately, so the two match rather than one being geometrically pure and the
  // other looking better. Rendered ball radius comes out at 130.7px for both.
  //
  // A replacement photograph needs re-measuring.
  // Scene table. One builder, many products - the scene decides the photograph,
  // the disc geometry and which inks are offered.
  //
  //   img      key into the photo set supplied by the Liquid block
  //   cal      cx, cy, r as fractions of the photo WIDTH, from pixel analysis
  //   discMM   visible disc diameter
  //   printMM  usable print circle
  //   lineMax  characters per line, tapered - outer lines get the shortest chord
  //   blocked  ink codes NOT offered on this finish
  //
  // BLOCKED IS DELIBERATELY EMPTY. Gold ink on a gold disc is invisible and white
  // on chrome is weak, but that is Nathan's printing judgement to give, exactly as
  // he gave it for the pink ball. The mechanism is here; the lists are his call.
  // ---------------------------------------------------------------------------
  // Wiring to the page. These four were dropped when this file was forked from the
  // golf builder, which meant the script threw ReferenceError: CFG is not defined on
  // its very first statement and the disc builder had never actually run - the empty
  // scene table hid it, because with no photo to place there was nothing to look at
  // and nothing obviously missing. Reading the page source could not show it either;
  // the markup was correct throughout. It took loading the page in a real browser.
  //
  // FORMID is the one with teeth: it names the product form that the four Line inputs
  // attach to, so without it buildLines() throws as well and the fields carrying the
  // customer's text into the order never exist.
  var ROOT    = document.getElementById("pab-disc");
  var CFG     = window.PAB_DISC || {};
  var FORMID  = CFG.formId || "";

  // Placeholder text. Fits the tightest caps in the range, 11/13/13/11 at 25 mm.
  //
  // "PARKLAND" was carried over from the golf builder and dropped 8 Sep 2026 on
  // Nathan's call. Parkland is a real Saskatchewan region and the name of real clubs
  // in it, so a preview using it reads as a specific customer's marker rather than an
  // example. Line 1 now says YOUR CLUB, which cannot be mistaken for anyone's, and
  // the rest are generic formats rather than named events.
  var SEED    = ["YOUR CLUB","MEMBER GUEST","LOW NET","2026"];
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // Scene calibration, measured 8 Sep 2026 from Nathan's eight outlined renders
  // (Downloads 18-25). Method: from a seed centre read off a gridded contact
  // sheet, cast 720 rays and take the strongest FALLING luminance gradient on
  // each, then algebraic least squares on those points, iterated to convergence.
  //
  // The first attempt used "darkest point on the ray" and failed on the three
  // 38 mm markers: their scalloped bevel puts a second dark circle inside the
  // search window, so the detector flipped between the two by angle and reported
  // 6-10% ellipticity on discs that are round. The gradient edge ignores the
  // dash gaps and the scallop shadows both, and brought those three to under 1%.
  //
  // Cross-check: on the four scenes where Nathan's drawn line is readable against
  // its surround (18, 22, 23, 25) the line sits at 0.985-1.005 of the fitted
  // radius, so the fit lands on his outline to within 1.5%. On 19, 20 and 21 the
  // surround is grass, which is too dark and too textured for that test; those
  // rest on the fit alone, which held to 0.06-1.13% across the acceptance sweep.
  //
  // cx, cy and r are fractions of the image WIDTH. All eight sources are square
  // 2048 x 2048; ar carries height/width so a non-square source cannot silently
  // shift the disc vertically.
  //
  // For the 38 mm markers, cal.r is the OUTER disc edge, all 38 mm of it. The
  // print circle is derived from printMM/discMM, so the 32 mm usable face that
  // Nathan measured on 8 Sep is drawn from the geometry, not from the photo.
  //
  // Gold needed a second pass. Its edge against grass is close in luminance, so
  // the luminance detector settled on a false minimum inside the disc; switching
  // the edge metric to red-minus-green, which separates gold metal from grass
  // where brightness does not, moved it onto the rim (rms 7.0 px against 11.3).
  // The three 38 mm finishes then landed within 0.3% of each other, which says
  // they are one render in three colours - so one clean render, recoloured, is
  // enough for all three, and any re-render has to cover all three together.
  //
  // WARNING. Every one of these is measured against an OUTLINED render, and the
  // asset that ships has to be the clean version of that exact file. A fresh
  // generation moves the disc by a few pixels and silently invalidates the whole
  // table, with no error anywhere: the preview would simply sit off the disc.
  // ---------------------------------------------------------------------------
  var SCENES = {
    "marker25_silver":  {img:"marker25_silver",  label:"25 mm silver marker",
                         cal:{cx:0.4990, cy:0.4914, r:0.3008, ar:1},
                         discMM:25, printMM:25, lineMax:[11,13,13,11], blocked:{}},
    "marker38_silver":  {img:"marker38_silver",  label:"38 mm silver marker",
                         cal:{cx:0.4930, cy:0.4752, r:0.2324, ar:1},
                         discMM:38, printMM:32, lineMax:[14,17,17,14], blocked:{}},
    "marker38_gold":    {img:"marker38_gold",    label:"38 mm gold marker",
                         cal:{cx:0.4929, cy:0.4779, r:0.2334, ar:1},
                         discMM:38, printMM:32, lineMax:[14,17,17,14], blocked:{}},
    "marker38_bronze":  {img:"marker38_bronze",  label:"38 mm bronze marker",
                         cal:{cx:0.4924, cy:0.4738, r:0.2320, ar:1},
                         discMM:38, printMM:32, lineMax:[14,17,17,14], blocked:{}},
    "hatclip_chrome":   {img:"hatclip_chrome",   label:"chrome hat clip",
                         cal:{cx:0.5559, cy:0.5334, r:0.1876, ar:1},
                         discMM:25, printMM:25, lineMax:[11,13,13,11], blocked:{}},
    "divot_chrome":     {img:"divot_chrome",     label:"chrome divot tool",
                         cal:{cx:0.4963, cy:0.2523, r:0.1177, ar:1},
                         discMM:25, printMM:25, lineMax:[11,13,13,11], blocked:{}},
    "divotfold_black":  {img:"divotfold_black",  label:"black folding divot tool",
                         cal:{cx:0.4906, cy:0.2222, r:0.1060, ar:1},
                         discMM:25, printMM:25, lineMax:[11,13,13,11], blocked:{}},
    "divotfold_chrome": {img:"divotfold_chrome", label:"chrome folding divot tool",
                         cal:{cx:0.4904, cy:0.2234, r:0.1055, ar:1},
                         discMM:25, printMM:25, lineMax:[11,13,13,11], blocked:{}}
  };
  var PHOTOS  = CFG.img || {};

  // The disc is drawn at 39% of the preview box, leaving the scene visible around it.
  var DISC_R_VIEW  = VIEW * 0.39;
  var PRINT_R_VIEW = DISC_R_VIEW * (PRINT_D / DISC_D);

  var mode = "text", fi = 0, ii = 0;

  // Current scene. Chosen by the selected variant where the product has finishes,
  // otherwise by the product tag the Liquid resolved. Never guessed from a name.
  var sceneKey = (ROOT && ROOT.getAttribute("data-pab-scene")) || "marker25_silver";
  var SC = SCENES[sceneKey] || SCENES["marker25_silver"];

  function setScene(key){
    if(!SCENES[key]) return false;
    sceneKey = key; SC = SCENES[key];
    PRINT_D = SC.printMM;
    DISC_D  = SC.discMM;
    LINE_MAX = SC.lineMax;
    PXMM = VIEW / DISC_D;
    PRINT_R_VIEW = DISC_R_VIEW * (PRINT_D / DISC_D);
    if(!inkAllowed(ii)) ii = 0;      // selected ink may not exist on this finish
    // The footer's print diameter belongs here with every other per-scene number. It
    // used to be written once at module level and again by the variant watcher, and
    // the module-level write ran BEFORE the opening scene was applied - so a 38 mm
    // marker read "25 mm" in the footer while the readout directly above it correctly
    // said 32. One writer, one truth.
    var fdEl = el("footD"); if(fdEl) fdEl.textContent = PRINT_D.toFixed(0) + " mm";
    buildLines();                    // per-line character caps change with the disc
    grids(); placePhoto(); draw();
    return true;
  }
  var img = null, zoom = 1, offX = 0, offY = 0;

  var el = function(id){ return document.getElementById(id); };
  // Empty everywhere means the customer has not started, so drawLines()
  // substitutes the placeholders and the ball is never blank on load.
  function drawLines(){
    var L = lines();
    for(var i=0;i<L.length;i++) if(L[i]) return L;
    return SEED.slice();
  }
  function lines(){
    var out = [];
    for(var i=0;i<MAX_LINES;i++){
      var v = (el("l"+(i+1)).value || "").toUpperCase().replace(/[^A-Z0-9 '&.\-]/g,"");
      out.push(v.slice(0, LINE_MAX[i]));
    }
    return out;
  }

  // Lines are set on a pitch derived from their own cap heights, not by carving the
  // circle into equal slots. The slot approach left a 1.7 mm line sitting in a 6 mm
  // band and the block read as mostly empty space.
  //
  // Circular problem: a line's cap depends on how far it sits from centre (the chord
  // is shorter near the edge), and how far it sits from centre depends on the pitch,
  // which depends on the caps. Solved by iterating, damped to stop it oscillating.
  var LEADING = 1.24;              // cap-to-cap pitch as a multiple of cap height
  var MAX_CAP = PRINT_D * 0.34;    // ceiling so a one-word line does not go silly

  // Two sizing models, both with pitch derived from cap height rather than equal slots.
  //
  //   fill    - each line grows to fill the chord where it sits. Biggest possible type,
  //             which on a 24 mm circle is the constraint that actually matters. Lines
  //             end up different sizes, which reads as deliberate on short stacks and
  //             busy on long ones.
  //   uniform - one cap height for the whole block, set by the tightest line. Reads as
  //             designed, but every line drops to the worst line's size.
  //
  // Nathan's call is fill by default; both are kept because the right answer depends on
  // the text. Either way the block is centred and the whole thing stays in the circle.
  var sizing = "fill";

  function capForChord(text, dyMM, ceiling){
    if(!text) return 0;
    var r = PRINT_D/2, f = FONTS[fi], wEm = Math.max(widthEm(text, fi), 0.01);
    var cap = Math.min(ceiling, r);
    for(var k=0;k<40;k++){
      var edge = Math.abs(dyMM) + cap/2;
      if(edge >= r*0.999){ cap *= 0.9; continue; }
      var avail = 2 * Math.sqrt(r*r - edge*edge) * 0.94;
      var next = Math.min(avail * f[4] / wEm, ceiling);
      if(Math.abs(next - cap) < 0.002){ cap = next; break; }
      cap = cap + (next - cap) * 0.55;
    }
    return Math.max(cap, 0);
  }

  function stack(caps){                       // centred positions from a set of caps
    var n = caps.length, pitches = [], i, total = 0;
    for(i=0;i<n-1;i++) pitches.push((caps[i]+caps[i+1])/2 * LEADING);
    for(i=0;i<pitches.length;i++) total += pitches[i];
    var y = -total/2, dys = [y];
    for(i=0;i<pitches.length;i++){ y += pitches[i]; dys.push(y); }
    return dys;
  }

  function layout(){
    var L = drawLines(), idx = [], i;
    for(i=0;i<L.length;i++) if(L[i].length) idx.push(i);
    var out = []; for(i=0;i<L.length;i++) out.push(null);
    var n = idx.length; if(!n) return out;
    var r = PRINT_D/2, j, dys = [], caps = [];

    if(sizing === "uniform"){
      var cap = MAX_CAP;
      for(var it=0; it<24; it++){
        var span = cap * LEADING * (n-1);
        dys = []; for(j=0;j<n;j++) dys.push(-span/2 + j*cap*LEADING);
        var allowed = MAX_CAP;
        for(j=0;j<n;j++){
          var fits = capForChord(L[idx[j]], dys[j], MAX_CAP);
          if(fits < allowed) allowed = fits;
        }
        var half = span/2 + cap/2;
        if(half > r) allowed = Math.min(allowed, cap * r / half);
        if(Math.abs(allowed - cap) < 0.002){ cap = allowed; break; }
        cap = cap + (allowed - cap) * 0.5;
        if(cap < 0.05){ cap = 0.05; break; }
      }
      caps = []; for(j=0;j<n;j++) caps.push(cap);
      dys = stack(caps);
    } else {
      for(j=0;j<n;j++) caps.push(PRINT_D/(n+1));
      for(var it2=0; it2<24; it2++){
        dys = stack(caps);
        // whole block must sit inside the circle
        var top = dys[0] - caps[0]/2, bot = dys[n-1] + caps[n-1]/2;
        var over = Math.max(-top, bot) / r;
        if(over > 1){ for(j=0;j<n;j++) caps[j] /= over; continue; }
        var moved = 0;
        for(j=0;j<n;j++){
          var want = capForChord(L[idx[j]], dys[j], MAX_CAP);
          moved = Math.max(moved, Math.abs(want - caps[j]));
          caps[j] = caps[j] + (want - caps[j]) * 0.5;
        }
        if(moved < 0.01) break;
      }
      dys = stack(caps);
      // final safety: if the settled block overhangs, scale it down together
      var t2 = dys[0] - caps[0]/2, b2 = dys[n-1] + caps[n-1]/2;
      var ov = Math.max(-t2, b2) / r;
      if(ov > 1){ for(j=0;j<n;j++) caps[j] /= ov; dys = stack(caps); }
    }

    for(j=0;j<n;j++) out[idx[j]] = { text:L[idx[j]], dyMM:dys[j], cap:caps[j] };
    return out;
  }

  function esc(s){ return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }

  function draw(){
    var ink = INKS[ii], font = FONTS[fi];
    placePhoto();
    var svg = "";
    // Dark inks multiply into the ball's own shading so the artwork sits on the
    // surface rather than floating over it. White ink cannot multiply - it would
    // vanish - so it is drawn normally.
    var blend = (ink[0] === "INK-06") ? "normal" : "multiply";
    svg += '<g style="mix-blend-mode:'+blend+'">';

    if(mode === "text"){
      var rows = layout();
      for(var i=0;i<rows.length;i++){
        var r = rows[i]; if(!r) continue;
        var mm2view = DISC_R_VIEW / (DISC_D/2);      // view units per mm, from the photo
        var capPx = r.cap * mm2view;
        var baseline = CY + r.dyMM*mm2view + capPx/2;
        svg += '<text x="'+CX+'" y="'+baseline.toFixed(2)+'" fill="'+ink[2]+'" text-anchor="middle" '
             + 'font-family="'+font[2]+', Impact, sans-serif" font-weight="'+font[3]+'" '
             + 'font-size="'+(capPx/font[4]).toFixed(2)+'" letter-spacing="0.3">'+esc(r.text)+'</text>';
      }
    }

    svg += '</g>';
    // print-circle guide, outside the blend group so it stays crisp over the photo
    svg += '<circle cx="'+CX+'" cy="'+CY+'" r="'+PRINT_R_VIEW.toFixed(2)+'" fill="none" '
         + 'stroke="#00CFC8" stroke-width="1.6" stroke-dasharray="6 5" opacity=".95"/>';
    el("ballSvg").innerHTML = svg;

    positionCanvas();
    if(mode === "photo") paintPhoto();
    el("photoCanvas").className = (mode === "photo" && img) ? "on" : "";

    report(); flags(); spec();
  }

  // Scale each photograph so its disc lands at exactly DISC_R_VIEW, then offset so
  // the ball's centre sits at the middle of the box. This is what makes white and
  // pink read as the same ball rather than two differently framed pictures.
  function placePhoto(){
    var wrap = el("ballwrap"), im = el("ballPhoto"), cal = SC.cal;
    if(!cal){ im.removeAttribute("src"); return; }   // scene not calibrated yet
    var box = wrap.clientWidth || 340;
    var want = (DISC_R_VIEW / VIEW) * box;         // disc radius we want, px
    var dispW = want / cal.r;                       // therefore the photo's display width
    im.src = PHOTOS[SC.img];
    im.style.width  = dispW.toFixed(2) + "px";
    im.style.height = "auto";
    im.style.left   = (box/2 - cal.cx*dispW).toFixed(2) + "px";
    im.style.top    = (box/2 - cal.cy*dispW*(cal.ar||1)).toFixed(2) + "px";
  }

  function positionCanvas(){
    var wrap = el("ballwrap"), c = el("photoCanvas");
    var w = wrap.clientWidth || 340;
    var d = (PRINT_R_VIEW*2 / VIEW) * w;
    c.style.width = d + "px"; c.style.height = d + "px";
    c.style.left = ((w - d)/2) + "px"; c.style.top = ((w - d)/2) + "px";
  }

  function paintPhoto(){
    var c = el("photoCanvas"), g = c.getContext("2d");
    g.clearRect(0,0,c.width,c.height);
    if(!img) return;
    var S = c.width;
    var base = Math.max(S/img.width, S/img.height);   // cover
    var s = base * zoom;
    var w = img.width*s, h = img.height*s;
    g.save();
    g.beginPath(); g.arc(S/2,S/2,S/2,0,Math.PI*2); g.clip();
    g.drawImage(img, (S-w)/2 + offX, (S-h)/2 + offY, w, h);
    g.restore();
  }

  function report(){
    var out = [];
    out.push('Disc <b>'+DISC_D.toFixed(0)+' mm</b>');
    out.push('Print area <b>'+PRINT_D.toFixed(0)+' mm</b>');
    if(mode === "text"){
      var rows = layout(), caps = [];
      for(var i=0;i<MAX_LINES;i++){
        var box = el("mm"+(i+1)), r = rows[i];
        if(!r){ box.textContent = "-"; box.className = "mm"; continue; }
        caps.push(r.cap);
        box.textContent = r.cap.toFixed(1)+" mm";
        box.className = "mm" + (r.cap < MIN_CAP ? " small" : "");
      }
      if(caps.length) out.push('Smallest cap <b>'+Math.min.apply(null,caps).toFixed(1)+' mm</b>');
    } else {
      for(var j=1;j<=MAX_LINES;j++){ el("mm"+j).textContent = "-"; el("mm"+j).className = "mm"; }
      out.push('Photo <b>'+(img ? Math.round(zoom*100)+'% zoom' : 'none chosen')+'</b>');
    }
    el("readout").innerHTML = out.join("");
  }

  // The BoHo Snipz rules, applied live instead of at quote time.
  function flags(){
    var ink = INKS[ii], warn = [], crit = [];

    // The golf builder's white-ink warning used to sit here, carried over whole by the
    // fork: "white ink on a white ball will not show", tested against `ball[3]`. There
    // is no ball in this builder and no `ball` variable either, so flags() threw a
    // ReferenceError the moment a white ink was selected - and because draw() runs
    // report(), flags(), then spec(), the throw took spec() down with it. The visible
    // symptom was nasty and quiet: the swatch highlighted, the preview redrew in white,
    // and the hidden Ink property stayed on whatever was selected before. A customer
    // could pick white and have the order say black.
    //
    // Not replaced with a disc equivalent. White on chrome, gold on gold and the rest
    // are printing judgements, and per item 258 those are Nathan's to make against the
    // live builder rather than mine to infer. The per-scene `blocked` lists are the
    // place for them, which removes a bad combination at the source instead of
    // describing it after the fact.

    // Contrast against the disc itself. Kept generic rather than hard-coded per
    // finish, because the finish list is Nathan's to set and this reads off it.

    if(mode === "photo"){
      // A flat brushed disc is a far kinder surface than a dimpled ball, so the
      // golf builder's warning does not carry over. What still bites is scale.
      warn.push('<strong>A photograph has to survive being '+SC.printMM+' mm across.</strong> '
        + 'A flat disc holds detail far better than a dimpled ball does, but a face smaller than about '
        + 'a third of the circle still will not read. We always proof a photo before it runs.');
    }

    if(mode === "text"){
      var rows = layout(), small = [];
      for(var i=0;i<rows.length;i++) if(rows[i] && rows[i].cap < MIN_CAP) small.push(i+1);
      if(small.length) crit.push('<strong>Line '+small.join(", ")+' prints at under '+MIN_CAP.toFixed(1)+' mm.</strong> '
        + 'That is below what reads reliably at this size. Shorten the line, or drop a line so the rest print bigger.');
      if(!rows.some(function(r){ return r; })) warn.push('Type something on a line to see it on the disc.');
    }

    var w = el("flagWarn"), c = el("flagCrit");
    w.innerHTML = warn.join("<br><br>"); w.className = "flag warn" + (warn.length ? " on" : "");
    c.innerHTML = crit.join("<br><br>"); c.className = "flag crit" + (crit.length ? " on" : "");
  }

  function spec(){
    var s = "PAB-DISC-" + sceneKey.toUpperCase() + "-" + INKS[ii][0].replace("-","");
    if(mode === "text"){
      var L = lines().filter(function(x){ return x.length; });
      s += "-" + FONTS[fi][0].replace("-","") + "-" + (L.join("|") || "EMPTY");
    } else {
      s += "-PHOTO-" + (img ? "Z"+Math.round(zoom*100) : "NONE");
    }
    s += "-D" + PRINT_D.toFixed(1) + "-V01-PROOF";
    el("spec").textContent = s;
    syncForm(s);
  }

  // ---- what rides on the order --------------------------------------------
  // Name and the four lines are real inputs, so an order still carries the text
  // if this script never runs. Everything else is a hidden mirror of the current
  // selection, rewritten on every draw. Fields belonging to the mode that is not
  // showing are disabled, because a disabled input does not submit - otherwise a
  // photo order would arrive carrying four empty Line properties.
  function setProp(id, value){
    var n = el(id); if(n) n.value = value;
  }
  function syncForm(specStr){
    setProp("pg-ink",  INKS[ii][1]);
    setProp("pg-font", mode === "text" ? FONTS[fi][1] : "");
    setProp("pg-size", mode === "text" ? (sizing === "fill" ? "Fill the circle" : "One size") : "");
    setProp("pg-crop", mode === "photo" && img
      ? ("zoom " + Math.round(zoom*100) + "%, offset " + Math.round(offX) + " / " + Math.round(offY))
      : "");
    setProp("pg-spec", specStr);
    var textMode = mode === "text";
    for(var i=0;i<MAX_LINES;i++){
      var n = el("l"+(i+1)); if(n) n.disabled = !textMode;
    }
    var f = el("file");   if(f) f.disabled = textMode;
    var fo = el("pg-font"); if(fo) fo.disabled = !textMode;
    var sz = el("pg-size"); if(sz) sz.disabled = !textMode;
    var cr = el("pg-crop"); if(cr) cr.disabled = textMode;
  }

  // ---- line inputs, built from LINE_MAX -----------------------------------
  function buildLines(){
    var seed = SEED;
    var h = "";
    for(var i=0;i<MAX_LINES;i++){
      h += '<div class="lineRow"><div>'
         + '<label class="f" for="l'+(i+1)+'">Line '+(i+1)+' <span class="cap">max '+LINE_MAX[i]+'</span></label>'
         + '<input type="text" id="l'+(i+1)+'" maxlength="'+LINE_MAX[i]+'" autocomplete="off"'
         + ' name="properties[Line '+(i+1)+']" form="'+FORMID+'" value=""'
         + (i===0 ? ' required' : '')
         + ' placeholder="'+(seed[i]||"").slice(0,LINE_MAX[i])+'"></div>'
         + '<div class="mm" id="mm'+(i+1)+'">-</div></div>';
    }
    el("lineRows").innerHTML = h;
    for(var j=0;j<MAX_LINES;j++) el("l"+(j+1)).addEventListener("input", draw);
    el("lineHint").innerHTML = 'Up to ' + MAX_LINES + ' lines. The outer lines sit nearer the edge of the '
      + 'print circle, so they hold fewer characters - <strong>' + LINE_MAX.join(' / ')
      + '</strong> from top to bottom. The millimetre figure beside each line is the real printed cap height. '
      + '<em>Fill the circle</em> lets every line grow as large as it can, so short lines print big. '
      + '<em>One size</em> sets the whole block in a single size.';
  }

  // ---- option grids -------------------------------------------------------
  // Pink only carries inks that read on it without help: black, navy, green, white.
  // Red is the BoHo Snipz failure and gold is too low in contrast - neither is offered
  // rather than warned about, so the choice cannot be made in the first place.
  // Per-scene ink gating. Same mechanism the pink ball uses: an ink that will not
  // hold up is not offered at all, rather than offered and then warned about.
  function inkAllowed(i){
    return !SC.blocked[INKS[i][0]];
  }

  function grids(){
    if(!inkAllowed(ii)) ii = 0;                    // selection was just removed - fall back to black
    el("inkGrid").innerHTML = INKS.map(function(k,i){
      if(!inkAllowed(i)) return "";
      return '<button class="opt" type="button" aria-pressed="'+(i===ii)+'" data-i="'+i+'" title="'+k[1]+'">'
           + '<span class="swatch" style="background:'+k[2]+';'
           + (k[0]==="INK-06" ? 'box-shadow:inset 0 0 0 1px var(--rule);' : '')+'"></span>'
           + '<span class="lb">'+k[1]+'</span></button>';
    }).join("");
    el("fontGrid").innerHTML = FONTS.map(function(f,i){
      return '<button class="opt" type="button" aria-pressed="'+(i===fi)+'" data-i="'+i+'" title="'+f[1]+'">'
           + '<span class="fnum" style="font-family:\''+f[2]+'\',Impact,sans-serif;font-weight:'+f[3]+'">Ag</span>'
           + '<span class="lb">'+f[1]+'</span></button>';
    }).join("");
    // Colour, not product name. The pink stock is moving from Srixon Lady Pink to
    // Pink Noodle Neon, and the preview should not have to change when it does.
    var blockedNames = [];
    for(var bk=0;bk<INKS.length;bk++) if(SC.blocked[INKS[bk][0]]) blockedNames.push(INKS[bk][1].toLowerCase());
    el("ballHint").textContent = "Printing on the " + SC.label + ". The print area is "
      + SC.printMM + " mm across"
      + (SC.printMM === SC.discMM ? ", the full face of the disc." : ", inside the bevelled edge.")
      + (blockedNames.length ? " " + blockedNames.join(" and ").replace(/^./,function(c){return c.toUpperCase();})
         + (blockedNames.length>1 ? " are" : " is") + " not offered on this finish." : "");
    wire("inkGrid", function(i){ ii=i; });
    wire("fontGrid", function(i){ fi=i; });
  }
  function wire(id, set){
    Array.prototype.forEach.call(el(id).querySelectorAll(".opt"), function(b){
      b.addEventListener("click", function(){ set(+b.dataset.i); grids(); draw(); });
    });
  }

  // ---- photo --------------------------------------------------------------
  el("file").addEventListener("change", function(e){
    var f = e.target.files && e.target.files[0];
    if(!f) return;
    var rd = new FileReader();
    rd.onload = function(ev){
      var im = new Image();
      im.onload = function(){
        img = im; zoom = 1; offX = 0; offY = 0;
        el("zoom").value = 100; el("zoomVal").textContent = "100%";
        el("drop").className = "drop has";
        el("dropThumb").style.backgroundImage = "url(" + ev.target.result + ")";
        el("dropTitle").textContent = f.name.length > 34 ? f.name.slice(0,31)+"…" : f.name;
        el("dropSub").textContent = im.width + " × " + im.height + " - drag the circle to reposition.";
        draw();
      };
      im.onerror = function(){
        el("dropTitle").textContent = "That file would not open";
        el("dropSub").textContent = "Some phone HEIC files need converting. Try a JPG or PNG.";
      };
      im.src = ev.target.result;
    };
    rd.readAsDataURL(f);
  });
  el("zoom").addEventListener("input", function(){
    zoom = (+this.value)/100; el("zoomVal").textContent = this.value + "%"; draw();
  });
  el("reCentre").addEventListener("click", function(){ offX=0; offY=0; draw(); });
  el("clearPhoto").addEventListener("click", function(){
    img=null; offX=0; offY=0; zoom=1;
    el("zoom").value=100; el("zoomVal").textContent="100%";
    el("drop").className="drop";
    el("dropThumb").style.backgroundImage="";
    el("dropTitle").textContent="Choose a photo";
    el("dropSub").textContent="JPG, PNG or HEIC from your phone. Nothing is uploaded - it stays in your browser.";
    draw();
  });

  // drag to pan
  (function(){
    var dragging=false, sx=0, sy=0, ox=0, oy=0;
    var wrap = el("ballwrap");
    function start(x,y){ if(mode!=="photo"||!img) return; dragging=true; sx=x; sy=y; ox=offX; oy=offY; }
    function move(x,y){
      if(!dragging) return;
      var w = wrap.clientWidth || 340;
      var scale = el("photoCanvas").width / ((PRINT_R_VIEW*2/VIEW)*w);
      offX = ox + (x-sx)*scale; offY = oy + (y-sy)*scale; paintPhoto();
    }
    wrap.addEventListener("mousedown", function(e){ start(e.clientX,e.clientY); });
    window.addEventListener("mousemove", function(e){ move(e.clientX,e.clientY); });
    window.addEventListener("mouseup", function(){ dragging=false; });
    wrap.addEventListener("touchstart", function(e){
      if(mode==="photo"&&img){ e.preventDefault(); start(e.touches[0].clientX,e.touches[0].clientY); }
    }, {passive:false});
    wrap.addEventListener("touchmove", function(e){
      if(dragging){ e.preventDefault(); move(e.touches[0].clientX,e.touches[0].clientY); }
    }, {passive:false});
    window.addEventListener("touchend", function(){ dragging=false; });
  })();

  // ---- modes --------------------------------------------------------------
  function setMode(m){
    mode = m;
    el("mText").setAttribute("aria-pressed", String(m==="text"));
    el("mPhoto").setAttribute("aria-pressed", String(m==="photo"));
    el("secText").style.display  = m==="text"  ? "" : "none";
    el("secPhoto").style.display = m==="photo" ? "" : "none";
    el("secFont").style.display  = m==="text"  ? "" : "none";
    el("secInk").style.display   = m==="text"  ? "" : "none";
    draw();
  }
  function setSizing(v){
    sizing = v;
    el("szFill").setAttribute("aria-pressed", String(v==="fill"));
    el("szUniform").setAttribute("aria-pressed", String(v==="uniform"));
    draw();
  }
  el("szFill").addEventListener("click", function(){ setSizing("fill"); });
  el("szUniform").addEventListener("click", function(){ setSizing("uniform"); });

  el("mText").addEventListener("click", function(){ setMode("text"); });
  el("mPhoto").addEventListener("click", function(){ setMode("photo"); });

  el("copy").addEventListener("click", function(){
    var t = el("spec").textContent, b = this;
    if(navigator.clipboard) navigator.clipboard.writeText(t).then(function(){
      b.textContent = "Copied"; setTimeout(function(){ b.textContent = "Copy order spec"; }, 1400);
    });
  });
  window.addEventListener("resize", function(){ placePhoto(); positionCanvas(); if(mode==="photo") paintPhoto(); });

  if(location.search.indexOf("pabdebug=1") > -1){
    var sb = el("specBox"); if(sb) sb.className = "spec on";
  }
  var fd = el("footD"); if(fd) fd.textContent = PRINT_D.toFixed(0) + " mm";

  // Follow the variant picker where the product has finishes. Listening to the
  // form's own inputs rather than a Horizon event keeps this independent of the
  // theme's internals, which is what has kept the other builders working across
  // four theme publishes. CFG.variantScenes maps an option value to a scene.
  // Follow the selected finish.
  //
  // This listens on the DOCUMENT, not on the product form, and that is deliberate.
  // Horizon renders the finish picker inside a <variant-picker> element that carries
  // its OWN <form class="variant-picker__form">; the buy-buttons product form is a
  // separate form elsewhere on the page. An earlier version listened on the product
  // form and queried it for the radios, which found nothing and never fired - the
  // preview would have sat on the default finish for ever, silently, with the price
  // and the SKU updating correctly around it.
  //
  // Listening on the document also survives Horizon re-rendering the picker markup
  // after a selection, which would detach a listener bound to the element itself.
  //
  // Both picker styles are covered: "buttons" renders radios carrying the option
  // value, "dropdowns" renders a select whose options carry the same values.
  (function watchVariant(){
    var map = CFG.variantScenes;
    if(!map) return;
    var has = false;
    for(var k in map){ if(Object.prototype.hasOwnProperty.call(map,k)){ has = true; break; } }
    if(!has) return;   // single-finish product, nothing to follow

    function apply(){
      // The recommendations section below can render its own <variant-picker>
      // elements for quick-add, so take the one Horizon marks as belonging to the
      // product this page is for, and only fall back to a looser match.
      var scope = document.querySelector('variant-picker[data-template-product-match="true"]')
               || document.querySelector("variant-picker")
               || document;
      var nodes = scope.querySelectorAll("select, input[type=radio]:checked");
      for(var i=0;i<nodes.length;i++){
        var v = nodes[i].value;
        if(!v) continue;
        v = String(v).trim().toLowerCase();
        if(map[v] && map[v] !== sceneKey){
          setScene(map[v]);   // updates the footer figure itself
          return;
        }
      }
    }
    document.addEventListener("change", apply);
    apply();
  })();

  // Apply the starting scene's GEOMETRY, not just its photograph.
  //
  // sceneKey is read off data-pab-scene at the top, and SC follows it, so the right
  // photo loaded from the start. But PRINT_D, DISC_D and LINE_MAX are module-level
  // and only ever reassigned inside setScene(), which the variant watcher calls only
  // when the selected value DIFFERS from the scene already set. On a 38 mm marker the
  // default variant is Silver and the tag scene is marker38_silver, so nothing
  // differed, setScene() never ran, and the page kept the 25 mm defaults: it showed
  // the right disc while telling the customer "print area 25 mm" against a real 32,
  // and capped the lines at 11/13/13/11 instead of 14/17/17/14.
  //
  // Wrong numbers under a correct picture is the worst shape this bug could take,
  // because everything visible looked right.
  if(!setScene(sceneKey)){ buildLines(); grids(); }
  setMode("text");   // explicit, so the opening state never depends on prior interaction
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
})();
